import * as React from "react"
const LockIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={12}
    height={14}
    fill="currentcolor"
    {...props}
  >
    <path
      fill="currentcolor"
      d="M10.083 4.667v-.584a4.083 4.083 0 0 0-8.166 0v.584H.167v7.583A1.75 1.75 0 0 0 1.917 14h8.166a1.75 1.75 0 0 0 1.75-1.75V4.667h-1.75Zm-7-.584a2.917 2.917 0 0 1 5.833 0v.584H3.083v-.584Zm7.583 8.167a.584.584 0 0 1-.583.583H1.917a.583.583 0 0 1-.584-.583V5.833h9.334v6.417Z"
    />
  </svg>
)
export default LockIcon
